import React from "react";
import { Switch } from "react-router-dom";
import { PublicRoute } from "../Router";

import Login from "./Components/login";
import Logout from "./Components/logout";

import { signedIn, logout } from "./action";
import { SecuritySelector, isSignedInSelector, UserSelector } from "./selector";

export const SecurityRouter = () => {
  return (
    <Switch>
      <PublicRoute path="/security/logout" component={Logout} />
      <PublicRoute path="/security/login" component={Login} />
    </Switch>
  );
};

export { SecuritySelector, isSignedInSelector, UserSelector, signedIn, logout };
